import {
  phone as formatterPhone,
  cpf as formatterCpf
} from '@loggi/js/formatters';
import moment from 'moment-timezone';
import formatterCnpj from '@loggi/js/formatters/cnpj';
import formatterCep from '@loggi/js/formatters/cep';

function formatText(type, text) {
  let formattedText = text;
  if (type && text) {
    switch (type) {
      case 'date':
        const textDate = isNaN(Number(text))
          ? new Date(text)
          : new Date(Number(text));
        formattedText = moment(textDate)
          .utc()
          .format('L');
        break;
      case 'cpf':
        formattedText = formatterCpf(text.toString());
        break;
      case 'cnpj':
        formattedText = formatterCnpj(text.toString());
        break;
      case 'phone':
        formattedText = formatterPhone(text.toString());
        break;
      case 'cep':
        formattedText = formatterCep(text.toString());
        break;
      default:
        return text;
    }
  }
  formattedText = formattedText !== 'Invalid date' ? formattedText : text;
  return formattedText;
}

export default formatText;
